
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ChecklistNodiDialog extends Serenity.EntityDialog<ChecklistNodiRow, any> {
        protected getFormKey() { return ChecklistNodiForm.formKey; }
        protected getIdProperty() { return ChecklistNodiRow.idProperty; }
        protected getLocalTextPrefix() { return ChecklistNodiRow.localTextPrefix; }
        protected getService() { return ChecklistNodiService.baseUrl; }
        protected getDeletePermission() { return ChecklistNodiRow.deletePermission; }
        protected getInsertPermission() { return ChecklistNodiRow.insertPermission; }
        protected getUpdatePermission() { return ChecklistNodiRow.updatePermission; }

        protected form = new ChecklistNodiForm(this.idPrefix);

        
        
    }
}